import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import RaisedButton from 'material-ui/RaisedButton';
import { translate } from 'react-i18next';

import PageBase from '../components/PageBase';
import AccountForm from '../components/AccountForm';
import * as accountActions from '../redux/modules/accounts';
import ConfirmDialog from '../components/ConfirmDialog';
import i18n from '../translations/i18n.js';

/*
PropTypes / DefaultProps
 */
const propTypes = {
  modifyAccount: PropTypes.func,
  fetchAccount: PropTypes.func,
  account: PropTypes.object,
  params: PropTypes.any,
  unloadCurrent: PropTypes.any,
  currentUser: PropTypes.any,
  changeActivationStatus: PropTypes.any,
  t: PropTypes.func,
};

const defaultProps = {
  account: {},
};

class AccountModify extends React.Component {
  constructor(props) {
    super(props);

    this.id = this.props.params.splat;

    this.state = {
      confirmDialogOpened: false,
      accountId: null,
    };
  }
  /*
    Lifecycle methods
   */
  componentWillMount() {
    this.props.fetchAccount(this.id);
  }

  componentWillUnmount() {
    this.props.unloadCurrent();
  }

  /*
    Custom methods
   */
  onModifyAccount = (values) => {
    this.props.modifyAccount(values);
  };

  openActivationDialog = () => {
    if (!this.props.account) {
      return;
    }

    this.setState({
      confirmDialogOpened: true,
    });
  };

  cancelActivationDialog = () => {
    this.setState({
      confirmDialogOpened: false,
    });
  };

  changeActivationStatus = () => {
    this.props.changeActivationStatus(this.props.account.id, !this.props.account.active);
    this.cancelActivationDialog();
  };

  render() {
    const { account } = this.props;
    let activationButton = null;
    let activationButtonLabel = null;
    let dialogQuestion = '';

    if (
      this.props.account &&
      this.props.currentUser &&
      this.props.currentUser.role === 'SUPER_ADMIN' &&
      this.props.account.id !== this.props.currentUser.id
    ) {
      let color = '#a4c639';
      dialogQuestion = this.props.t('activate_user_question');
      activationButtonLabel = this.props.t('activate');

      if (this.props.account.active) {
        color = '#D5977B';
        dialogQuestion = this.props.t('deactivate_user_question');
        activationButtonLabel = this.props.t('deactivate');
      }

      activationButton = (
        <RaisedButton
          label={activationButtonLabel}
          onClick={this.openActivationDialog}
          backgroundColor={color}
          labelStyle={{ color: 'white' }}
        />
      );
    }

    return (
      <div>
        <PageBase title={this.props.t('modify_account')} rightComponent={activationButton}>
          <AccountForm onSubmit={this.onModifyAccount} isModify initialValues={account} />
        </PageBase>

        <ConfirmDialog
          open={this.state.confirmDialogOpened}
          text={dialogQuestion}
          onConfirm={this.changeActivationStatus}
          onCancel={this.cancelActivationDialog}
        />
      </div>
    );
  }
}

AccountModify.defaultProps = defaultProps;
AccountModify.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    account: state.accounts.current,
    translate: getTranslate(state.locale),
    currentUser: state.auth.current,
  };
}

const extended = translate(['translations'], { i18n })(AccountModify);
export default connect(mapStateToProps, accountActions)(extended);



// WEBPACK FOOTER //
// ./src/containers/AccountModify.js